<template>
  <div class="hk">
    <div class="banner">
      <div class="top" ref="topref">
        <Header></Header>
      </div>

      <div
        class="banner_container"
        :style="{ backgroundImage: `url('${banner}')` }"
      >
        <div class="title">
          <div class="title_en">{{ title.en }}</div>
          <div class="title_cn">{{ title.cn }}</div>
        </div>

        <div class="arrow">
          <lottie
            :options="defaultOptions"
            :height="114"
            :width="114"
            @animCreated="handleAnimation"
          />
        </div>
      </div>
    </div>

    <div class="main">
      <slot></slot>
    </div>
    <div class="end">
      <Footer></Footer>
    </div>
  </div>
</template>
  <script>
import arrow from "@/assets/arrow_down.json";
import Footer from "@/components/footer.vue";
import Header from "@/components/header.vue";
import lottie from "vue-lottie";

export default {
  components: {
    Header,
    lottie,
    Footer,
  },
  props: {
    title: {
      type: Object,
      default: () => ({ cn: "", en: "" }),
    },
    banner: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      documentTitle:'华科金融',
      defaultOptions: { animationData: arrow },
    };
  },
  methods: {
    setDocumentTitle(title) {
      document.title = title;
    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    scroll() {
      let _this = this;
      window.addEventListener("scroll", function () {
        // console.log('y轴距离',window.scrollY);
        if (window.scrollY > 100 && _this.$refs.topref) {
          _this.$refs.topref.style.background = "rgba(255, 255, 255, 1)";
          _this.$refs.topref.style.boxShadow = "0px 0px 8px #ddd";
        }

        if (window.scrollY <= 100 && _this.$refs.topref) {
          _this.$refs.topref.style.background = "rgba(255, 255, 255, 0)";
          _this.$refs.topref.style.boxShadow = "none";
        }
      });
    },
  },
  mounted() {
    this.scroll();
  },
  watch: {
    '$route': {
      handler: function(route) {
        if (route.meta && route.meta.title) {
          this.setDocumentTitle(route.meta.title);
        }
      },
      immediate: true
    }
  }
};
</script>
  
  <style lang="scss" scoped>
.hk {
  color: #1c1c1c;
  text-align: left;
}
.end {
  width: 100%;
}
.banner {
  width: 100%;
  height: 100vh;
  .banner_container {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100vh;
  }
  .top {
    width: 100%;
    height: 100px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    transition: all 1s;
  }
}

.title {
  width: 700px;
  height: 100px;
  position: absolute;
  top: 355px;
  left: 88px;
  .title_en {
    font-family: MessapiaBlod, sans-serif;
    font-size: 48px;
    line-height: 56px;
    color: transparent;
    text-transform: none;
    -webkit-text-stroke: 1px #1c1c1c;
  }
  .title_cn {
    width: 192px;
    height: 48px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    font-size: 48px;
    line-height: 56px;
    text-transform: none;
  }
}

.arrow {
  width: 114px;
  height: 114px;
  position: absolute;
  bottom: 58px;
  left: 903px;
}
</style>